jQuery( document ).ready(function() {

    // CircleType
    jQuery(".round-buttons-container .border-text").each(function() {
        var circleType = new CircleType(jQuery(this)[0]);
        circleType.radius(155);
        // Border text offset
        if( jQuery(this).data('border-text-offset') ) {
            jQuery(this).css({ 'transform' : 'rotate('+jQuery(this).data('border-text-offset')+'deg)' });
        }
        jQuery(this).parents('.round-buttons-item-container').addClass('scale-ready');
    });

});